module.exports = __webpack_public_path__ + "static/img/news_program_3.0ff56ae4.jpg";